import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH } from '../config/gameConstants';
import { ChaosFrame, SceneKeys, TextureKeys } from '../config/keys';
import { ChaosSoundManager } from '../managers/ChaosSoundManager';

export class MenuScene extends Phaser.Scene {
  private soundManager = new ChaosSoundManager();
  private muteButton!: Phaser.GameObjects.Text;

  constructor() {
    super(SceneKeys.Menu);
  }

  create(): void {
    this.add.tileSprite(0, 0, GAME_WIDTH, GAME_HEIGHT, TextureKeys.Background).setOrigin(0);

    this.add
      .text(GAME_WIDTH / 2, 84, 'Squirrel Launcher\nChaos', {
        fontFamily: '"Trebuchet MS", "Comic Sans MS", sans-serif',
        fontSize: '60px',
        lineSpacing: -10,
        color: '#28221a',
        align: 'center',
        stroke: '#fff7d8',
        strokeThickness: 9,
      })
      .setOrigin(0.5);

    const cannon = this.add.image(212, 334, TextureKeys.ChaosSheet, ChaosFrame.Cannon).setScale(0.54).setAngle(-5);
    const squirrel = this.add.sprite(506, 258, TextureKeys.ChaosSheet, ChaosFrame.SquirrelHappy).setScale(0.44);
    const soda = this.add.image(690, 354, TextureKeys.ChaosSheet, ChaosFrame.Soda).setScale(0.34).setAngle(4);

    this.tweens.add({
      targets: squirrel,
      y: squirrel.y - 20,
      angle: 8,
      duration: 520,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.inOut',
    });
    this.tweens.add({
      targets: [cannon, soda],
      scaleX: '+=0.02',
      scaleY: '+=0.02',
      duration: 480,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.inOut',
    });

    this.add
      .text(GAME_WIDTH / 2, 438, 'move mouse to aim, click the power meter', {
        fontFamily: '"Trebuchet MS", "Comic Sans MS", sans-serif',
        fontSize: '24px',
        color: '#3f3324',
        backgroundColor: '#fff7d8',
        padding: { x: 18, y: 8 },
      })
      .setOrigin(0.5);

    const startButton = this.add
      .text(GAME_WIDTH / 2, 492, 'START CHAOS', {
        fontFamily: '"Trebuchet MS", "Comic Sans MS", sans-serif',
        fontSize: '30px',
        color: '#28221a',
        backgroundColor: '#f8d36d',
        padding: { x: 30, y: 13 },
      })
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true });

    this.muteButton = this.add
      .text(GAME_WIDTH - 22, 18, this.soundManager.isMuted() ? 'sound off' : 'sound on', {
        fontFamily: '"Trebuchet MS", "Comic Sans MS", sans-serif',
        fontSize: '16px',
        color: '#28221a',
        backgroundColor: '#fff7d8',
        padding: { x: 10, y: 6 },
      })
      .setOrigin(1, 0)
      .setInteractive({ useHandCursor: true });

    startButton.on(Phaser.Input.Events.POINTER_DOWN, () => this.startGame());
    this.muteButton.on(Phaser.Input.Events.POINTER_DOWN, (_pointer: Phaser.Input.Pointer, _x: number, _y: number, event: Phaser.Types.Input.EventData) => {
      event.stopPropagation();
      const muted = this.soundManager.toggleMuted();
      this.muteButton.setText(muted ? 'sound off' : 'sound on');
    });

    this.input.keyboard?.once('keydown-SPACE', () => this.startGame());
    this.input.keyboard?.once('keydown-ENTER', () => this.startGame());
  }

  private startGame(): void {
    this.scene.start(SceneKeys.Game);
  }
}
